















































import Vue from 'vue';
import { Prop } from 'vue/types/options';
import { Backup } from '@/openapi-types';
import * as api from '@/util/api';
import { encodePathParameter } from '@/util/api';
import { mapActions } from 'pinia';
import { useNotifications } from '@/store/modules/notifications';

export default Vue.extend({
  name: 'DeleteBackupButton',
  props: {
    canBackup: {
      type: Boolean,
      default: false,
      required: true,
    },
    backup: {
      type: Object as Prop<Backup>,
      required: true,
    },
  },
  data() {
    return {
      showConfirmation: false,
      deleting: false,
    };
  },
  methods: {
    ...mapActions(useNotifications, ['showError', 'showSuccess']),
    async deleteBackup() {
      this.deleting = true;
      this.showConfirmation = false;
      api
        .remove(`/backups/${encodePathParameter(this.backup.filename)}`)
        .then(() => {
          this.$emit('deleted');
          this.showSuccess(
            this.$t('backup.action.delete.success', {
              file: this.backup.filename,
            }),
          );
        })
        .catch((error) => this.showError(error))
        .finally(() => (this.deleting = false));
    },
  },
});
